export default __webpack_public_path__ + "static/media/006-greek pillars.cd97471f.svg";